webpackJsonp([159457557832050],{

/***/ 750:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/bamboo-delicacies/"},"excerpt":"If you love bamboo shoots as much as I do, join me on my next expedition to find the most delicate shoots in the world. I’ll let past…","timeToRead":1,"frontmatter":{"title":"Bamboo Delicacies","tags":["bamboo","delicacies","mammals","pandas"]}}}]}},"pathContext":{"tag":"bamboo"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-bamboo-58c14a44266411df4aab.js